import dayjs from 'dayjs';

export default {
    name: 'transform-participants-list',
    data () {
        return {}
    },
    computed: {},
    watch: {},
    created () {},
    mounted () {},
    methods: {
        transformParticipantsList (participants) {
            const stats_orders = { 'not_requested': 0, 'canceled': 1, 'requested': 2, 'in_progress': 3, 're_progress': 4, 'in_assessment': 5, 'completed': 6, 'eco_vadis': 7 }
            const isNull_date = (_date) => _date === 'None' ? null : _date
            // 영문·중문은 일·월 순서가 헷갈리지 않는 YYYY-MM-DD 로 통일한다
            const isNull_date_dis = (_date) => !_date ? null : {
                date: dayjs(_date).format('YYYY년 MM월 DD일'),
                time: dayjs(_date).format('HH시 mm분')
            }
            const isNull_date_dis_en = (_date) => !_date ? null : {
                date: dayjs(_date).format('YYYY-MM-DD'),
                time: dayjs(_date).format('HH:mm')
            }
            return participants.reduce((_participants, _par) => {
                if (_par.total_score !== null && typeof _par.total_score !== 'undefined') {
                    _par.total_score_segment = _par.total_score !== null && _par.total_score !== 'None'
                        ? Math.floor(_par.total_score / 10) * 10
                        : null
                    if (_par.total_score_segment !== null && _par.total_score_segment < 10) {
                        _par.total_score_segment = 10
                    }
                }
                _par.requested_ts = isNull_date(_par.requested_ts)
                _par.in_progress_ts = isNull_date(_par.in_progress_ts)
                _par.in_assessment_ts = isNull_date(_par.in_assessment_ts)
                _par.completed_ts = isNull_date(_par.completed_ts)
                _par.duedate_ts = isNull_date(_par.duedate_ts)

                _par.requested_ts_dis_en = isNull_date_dis_en(_par.requested_ts)
                _par.in_progress_ts_dis_en = isNull_date_dis_en(_par.in_progress_ts)
                _par.in_assessment_ts_dis_en = isNull_date_dis_en(_par.in_assessment_ts)
                _par.completed_ts_dis_en = isNull_date_dis_en(_par.completed_ts)
                _par.duedate_ts_dis_en = isNull_date_dis_en(_par.duedate_ts)

                _par.requested_ts_dis = isNull_date_dis(_par.requested_ts)
                _par.in_progress_ts_dis = isNull_date_dis(_par.in_progress_ts)
                _par.in_assessment_ts_dis = isNull_date_dis(_par.in_assessment_ts)
                _par.completed_ts_dis = isNull_date_dis(_par.completed_ts)
                _par.duedate_ts_dis = isNull_date_dis(_par.duedate_ts) 
                _participants.push(_par)
                return _participants
            }, [])
            .sort((a, b) => stats_orders[b.status_code] - stats_orders[a.status_code])
            .sort((a, b) => b.completed_rate - a.completed_rate)
        }
    }
}